import {
  SET_AVAILABILITY_PRODUCTS,
  SET_SEARCH_START,
  SET_SEARCH_FINISH,
  SET_SEARCH_LOADING,
  SET_SEARCH_LOCATIONS,
  SET_SEARCH_LOCATIONS_LOADING,
  SET_SELECTED_LOCATION,
  SET_SEARCH_META
} from '../actions/search';
import dayjs from "../../dayjs/dayjs_timezone";
import immutableUpdate from "react-addons-update";

const initialState = {
  loading: false,
  locationLoading: false,
  locations: [],
  meta: {},
  products: [],
  selectedLocation: null,
  start: dayjs(),
  finish: dayjs().add(7, 'days'),
};

export default function search(state = initialState, action) {
  switch (action.type) {
    case SET_AVAILABILITY_PRODUCTS:
      return immutableUpdate(state, {
        products: { $set: action.products },
      });

    case SET_SEARCH_START:
      return immutableUpdate(state, {
        start: { $set: action.start },
      });

    case SET_SEARCH_FINISH:
      return immutableUpdate(state, {
        finish: { $set: action.finish },
      });

    case SET_SEARCH_LOADING:
      return immutableUpdate(state, {
        loading: { $set: action.loading },
      });

    case SET_SEARCH_META:
      return immutableUpdate(state, {
        meta: { $set: action.meta },
      });

    case SET_SEARCH_LOCATIONS:
      return immutableUpdate(state, {
        locations: { $set: action.locations },
      });

    case SET_SELECTED_LOCATION:
      return immutableUpdate(state, {
        selectedLocation: { $set: action.location },
      });

    case SET_SEARCH_LOCATIONS_LOADING:
      return immutableUpdate(state, {
        selectedLocation: { $set: action.loading },
      });

    default:
      return state;
  }
}
